module.exports = __webpack_public_path__ + "static/logo.214800d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 114
// module chunks = 14943580662024 114276838955818